import { type FC } from 'react'
import { useFormContext } from 'react-hook-form'

import { type DirectContactFormSubmitStatus } from '../../hooks/useDirectContactFormSubmit'

import { DirectContactFormHookFormDialogFormContent } from './DirectContactFormHookFormDialogFormContent'
import { type DirectContactFormHookFormDialogValues } from './DirectContactFormHookFormDialogModel'
import { type DirectContactFormHookFormFieldsProps } from './DirectContactFormHookFormFields'

export const DirectContactFormHookFormDialogForm: FC<{
  configuration: DirectContactFormHookFormFieldsProps['configuration']
  isMutating: boolean
  onSubmit: (values: DirectContactFormHookFormDialogValues) => Promise<void>
  submitStatus: DirectContactFormSubmitStatus
}> = ({ configuration, isMutating, onSubmit, submitStatus }) => {
  const { handleSubmit } =
    useFormContext<DirectContactFormHookFormDialogValues>()
  const submit = handleSubmit(onSubmit)

  return (
    <form
      className="flex flex-col gap-4"
      data-qa-id="direct-contact-hook-form-dialog-form"
      noValidate
      onSubmit={(event) => {
        event.preventDefault()
        void submit(event)
      }}
    >
      <DirectContactFormHookFormDialogFormContent
        configuration={configuration}
        isMutating={isMutating}
        submitStatus={submitStatus}
      />
    </form>
  )
}
